<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane :tab="$t('Divisor Cli Neg')" key="1">
      <g-master
        :name="master.endpoint"
        :endpoint="master.endpoint"
        :tableSetup="master.tableSetup"
        :modalFieldsSetup="master.modalFieldsSetup"
        @edit="onModalOpen"
        @create="onModalOpen"
      >
        <template slot="masterModal" slot-scope="{ record }">
          <a-row :key="record && (record.id || 'nuevo')" :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown
                :key="`grupo-${(record && (record.id || 'nuevo'))}-${record && (record.grupo || '')}`"
                endpoint="hierarchy_lookup"
                style="width: 100%"
                :label="$t('Grupo')"
                :decorator="['grupo', { rules: [{ required: false}] }]"
                :params="grupo"
                :selectedObj.sync="grupoSeleccionado"
              />
            </a-col>

            <a-col v-bind="colOptions">
              <g-dropdown
                :key="`puesto-${fatherId(record)}-${record && (record.id || 'nuevo')}`"
                endpoint="hierarchy_lookup"
                style="width: 100%"
                :label="$t('Puesto')"
                :decorator="['puesto', { rules: [{ required: false}] }]"
                :params="puestoParamsFor(record)"
                :selectedObj.sync="puestoSeleccionado"
              />
            </a-col>

            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Divisor')" v-bind="fiOptions">
                <a-input-number
                  style="width: 100%"
                  v-decorator="['divisor', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},

        grupoSeleccionado: {},
        puestoSeleccionado: {},

        grupo: {
          h_lookup_type: 'ID_H_ATT1'
        },

        master: {
          endpoint: 'divisor_cli_neg',
          tableSetup: {
            tableConfig: {rowKey: 'id'},
            columns: [
              {title: 'Grupo', dataIndex: 'grupo_desc', sorter: true},
              {title: 'Puesto', dataIndex: 'puesto_desc', sorter: true},
              {title: 'Divisor', dataIndex: 'divisor', sorter: true},
              {title: 'Creado Por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado El', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado Por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado El', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'grupo'},
            {name: 'puesto'},
            {name: 'divisor'}
          ]
        }
      }
    },

    watch: {
      grupoSeleccionado: {
        handler () {
          this.puestoSeleccionado = {}
        },
        deep: true
      }
    },

    methods: {
      onModalOpen (record) {
        // Sincroniza estado solo al abrir modal
        this.grupoSeleccionado = (record && record.grupo)
          ? {value: record.grupo, label: record.grupo_desc}
          : {}

        this.puestoSeleccionado = (record && record.puesto)
          ? {value: record.puesto, label: record.puesto_desc}
          : {}
      },
      fatherId (record) {
        const fromUI = (this.grupoSeleccionado && this.grupoSeleccionado.value)
        const fromRecord = (record && record.grupo)
        return fromUI || fromRecord || ''
      },
      puestoParamsFor (record) {
        const fromRecord = record && record.grupo
        const fromUI = this.grupoSeleccionado && this.grupoSeleccionado.value
        return {
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: fromRecord || fromUI || ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/DivisorCliNeg/DivisorCliNeg.vue